import React from 'react';
import { IS_EUROPE, BRAND, SUPPORT_EMAIL } from '../config/region';
import { t } from '../i18n';
import LegalPage from './LegalPage';

/* The Russian page is written against the Law on Protection of Consumer Rights and the YooKassa
   flow; it is kept verbatim for ainovel.ru. */
const RussianRefundPage = () => (
  <LegalPage title="Политика возврата">
    <p className="lp-subtitle">Редакция от 27.02.2026</p>

    <h2>1. Общие условия возврата</h2>
    <p>Настоящая Политика возврата регулирует порядок возврата денежных средств за приобретённые на сайте AINovel (ainovel.ru) виртуальные товары (звёзды, используемые для обмена на сообщения в новеллах).</p>
    <p>Согласно положениям Закона Российской Федерации от 07.02.1992 № 2300-1 «О защите прав потребителей» возврат денежных средств возможен при соблюдении следующих условий:</p>
    <ul>
      <li>Товар не был использован (звёзды не были обменяны на сообщения в новелле)</li>
      <li>С момента покупки прошло не более 14 (четырнадцати) календарных дней</li>
      <li>Покупатель предоставил доказательства совершения покупки</li>
    </ul>
    <p><strong>Особенности возврата цифровых товаров:</strong> Приобретаемые звёзды являются цифровым виртуальным товаром. Возврат возможен только при условии, что они не были использованы. После обмена звёзд на сообщения в новелле возврат невозможен, так как товар считается оказанной услугой.</p>

    <h2>2. Перечень документов для оформления возврата</h2>
    <p>Для оформления возврата денежных средств покупатель должен предоставить:</p>
    <ul>
      <li>Заявление на возврат — в свободной форме</li>
      <li>Чек (или иной документ, подтверждающий оплату) — электронный чек, пришедший на указанную при покупке электронную почту</li>
      <li>Номер заказа — идентификатор транзакции в системе AINovel</li>
      <li>Данные покупателя — ФИО, адрес электронной почты, указанный при регистрации</li>
      <li>Дата покупки — точная дата приобретения товара</li>
    </ul>

    <h2>3. Порядок оформления возврата</h2>
    <p>Для оформления возврата денежных средств покупателю необходимо:</p>
    <ul>
      <li>Составить заявление на возврат денежных средств в свободной форме</li>
      <li>Направить заявление на электронную почту: ainovel@yandex.ru с темой письма «Возврат товара»</li>
      <li>Дождаться подтверждения получения заявления от службы поддержки (в течение 2 рабочих дней)</li>
      <li>Предоставить дополнительные сведения при необходимости</li>
      <li>Дождаться решения по заявлению</li>
    </ul>
    <p><strong>Содержание заявления на возврат:</strong></p>
    <ul>
      <li>Фамилия, имя, отчество покупателя</li>
      <li>Адрес электронной почты, указанный при регистрации</li>
      <li>Номер заказа или дата покупки</li>
      <li>Наименование товара (звёзды AINovel)</li>
      <li>Сумма, подлежащая возврату</li>
      <li>Причина возврата (по желанию)</li>
      <li>Банковские реквизиты для возврата денежных средств</li>
      <li>Дата и подпись</li>
    </ul>

    <h2>4. Сроки возврата денежных средств</h2>
    <p>После получения и рассмотрения заявления на возврат:</p>
    <ul>
      <li>Срок рассмотрения претензии: до 10 (десяти) рабочих дней</li>
      <li>Срок возврата денежных средств: в течение 14 (четырнадцати) дней с момента принятия положительного решения по заявлению</li>
    </ul>
    <p>Денежные средства возвращаются тем же способом, которым была произведена оплата. После осуществления возврата на электронную почту покупателя направляется подтверждение с указанием даты и суммы возврата.</p>

    <h2>5. Основания для отказа в возврате</h2>
    <p>Мы оставляем за собой право отказать в возврате денежных средств в следующих случаях:</p>
    <ul>
      <li>Звёзды были полностью или частично использованы для обмена на сообщения в новеллах</li>
      <li>С момента покупки прошло более 14 календарных дней</li>
      <li>Покупатель не предоставил доказательств совершения покупки</li>
      <li>Заявление на возврат направлено с нарушением установленного порядка</li>
    </ul>

    <h2>6. Контакты</h2>
    <p>По всем вопросам, связанным с возвратом товаров, обращайтесь:</p>
    <ul>
      <li>Электронная почта: ainovel@yandex.ru</li>
    </ul>
    <p>Политика возврата действует с момента её публикации на сайте и может быть изменена в любое время без предварительного уведомления пользователей.</p>
    <p>AINovel © 2026</p>
  </LegalPage>
);

/*
 * Refunds, europe.
 *
 * Wording follows the signed User Agreement rather than being invented here: it is the document
 * that grants the 14-day withdrawal right under Directive 2011/83/EU and the UK Consumer Contracts
 * Regulations 2013, and that states the exception for a service the buyer asked to start
 * immediately. Anything said here that the Agreement does not say would be a second, conflicting
 * contract.
 */
const PlotexRefundPage = () => (
  <LegalPage
    title={t('Политика возврата')}
    description={t('Условия возврата средств за звёзды на платформе {0}: право на отказ в течение 14 дней, исключения и порядок обращения.', BRAND)}
  >
    <h2>{t('Что вы покупаете')}</h2>
    <p>
      {t('Звёзды — виртуальные единицы, которые используются только внутри платформы для отправки сообщений персонажам. Они не являются денежными средствами, не подлежат обмену обратно на деньги и не переносятся за пределы платформы.')}
    </p>

    <h2>{t('Право на отказ в течение 14 дней')}</h2>
    <p>
      {t('Если вы потребитель, проживающий в Европейском союзе или Великобритании, вы вправе отказаться от договора в течение 14 календарных дней с момента покупки — в соответствии с Директивой 2011/83/ЕС и Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013 (Великобритания).')}
    </p>
    <p>
      {t('Право на отказ не применяется, если вы прямо согласились на немедленное начало оказания услуги до истечения срока отказа и подтвердили, что теряете право на отказ после того, как услуга будет оказана полностью. На практике это означает: неиспользованные звёзды подлежат возврату в течение 14 дней, уже потраченные — нет.')}
    </p>

    <h2>{t('Когда возврат невозможен')}</h2>
    <ul>
      <li>{t('Звёзды уже потрачены на сообщения персонажам — услуга оказана.')}</li>
      <li>{t('С момента покупки прошло более 14 дней, если иное не предусмотрено императивными нормами вашей страны.')}</li>
      <li>{t('Аккаунт заблокирован или удалён за существенное нарушение Пользовательского соглашения.')}</li>
    </ul>

    <h2>{t('Как запросить возврат')}</h2>
    <p>
      {t('Напишите на {0} с адреса электронной почты, привязанного к аккаунту, и укажите дату покупки, сумму и причину обращения. Мы отвечаем в течение 1–3 рабочих дней.', SUPPORT_EMAIL)}
    </p>
    <p>
      {t('Одобренный возврат перечисляется тем же способом оплаты, которым была совершена покупка, в срок, установленный платёжной системой. Соответствующее количество звёзд списывается с баланса.')}
    </p>

    <h2>{t('Ваши законные права')}</h2>
    <p>
      {t('Эта политика не ограничивает права, предоставленные вам императивными нормами законодательства о защите прав потребителей вашей страны. В случае противоречия применяются нормы закона. Полные условия приведены в Пользовательском соглашении.')}
    </p>
  </LegalPage>
);

const RefundPage = () => (IS_EUROPE ? <PlotexRefundPage /> : <RussianRefundPage />);

export default RefundPage;
